<template>
  <div>
    <v-snackbar top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <v-card class="d-flex flex-column">
      <v-card-title class="grid-close">
        <span v-if="!loading" class="headline"
          >Información de {{ device.device_name }}</span
        >
        <v-btn
          style="right: 10px; top: 10px"
          icon
          color="primary"
          fab
          absolute
          @click="$emit('cancel')"
          v-if="!loading"
        >
          <v-icon dark>fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row v-if="loading">
            <v-col
              v-for="(item, index) of 4"
              :key="index"
              cols="12"
              sm="3"
              md="3"
            >
              <v-skeleton-loader
                type="image"
                height="120px"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row v-else class="ml-3">
            <v-col cols="12" sm="12" md="12">
              <div class="general">
                <span :class="device.is_online ? 'online' : 'offline'">
                  <v-icon :class="device.is_online ? 'online' : 'offline'">
                    fas fa-signal</v-icon
                  >
                  Dispositivo
                  {{ device.is_online ? "en linea" : "fuera de linea." }}</span
                >
                <span style="text-align: end"
                  >Última conexión : {{ getDate }}</span
                >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <i
                      v-on="on"
                      @click="getDeviceStatus"
                      class="fas fa-sync-alt"
                    ></i>
                  </template>
                  <span
                    >Clic para actualizar la información del dispositivo</span
                  >
                </v-tooltip>
              </div>
            </v-col>

            <div class="ml-5 font-weight-bold" v-if="!device.is_online">
              Se muestra información de la última conexión realizada con el
              dispositivo.
            </div>

            <v-col cols="12" sm="12" md="12">
              <v-divider></v-divider>
            </v-col>

            <v-col class="backColor" cols="12" sm="3" md="3">
              <div class="item">
                <v-icon style="text-align: start">
                  fas fa-temperature-high</v-icon
                >
                <span style="text-align: center"> Temperatura </span>
                <span style="text-align: end">~{{ device.cpu_temp }} °C</span>
              </div>
              <v-progress-linear
                :value="device.cpu_temp"
                :color="device.cpu_temp < 80 ? 'green' : 'red'"
                style="border-radius: 20px; max-width: 95%"
                class="mt-5"
                height="15"
              >
              </v-progress-linear>
            </v-col>
            <v-col class="backColor" cols="12" sm="2" md="2">
              <div class="item">
                <v-icon style="text-align: start"> fas fa-microchip</v-icon>
                <span style="text-align: center"> CPU </span>
                <span style="text-align: end">~{{ device.cpu_usage }} %</span>
              </div>
              <v-progress-linear
                :value="device.cpu_usage"
                :color="device.cpu_usage < 80 ? 'green' : 'red'"
                style="border-radius: 20px; max-width: 95%"
                class="mt-5"
                height="15"
              >
              </v-progress-linear>
            </v-col>

            <v-col class="backColor" cols="12" sm="3" md="3">
              <div class="item">
                <v-icon style="text-align: start"> fas fa-memory</v-icon>
                <span style="text-align: center"> Memoria </span>
                <span style="text-align: end">{{ getMemory }} GB</span>
              </div>
              <v-progress-linear
                :value="(device.memory_usage / device.memory_total) * 100"
                :color="
                  (device.memory_usage / device.memory_total) * 100 < 50
                    ? 'green'
                    : 'red'
                "
                style="border-radius: 20px; max-width: 95%"
                class="mt-5"
                height="15"
              >
              </v-progress-linear>
            </v-col>

            <v-col class="backColor" cols="12" sm="3" md="3">
              <div class="item">
                <v-icon style="text-align: start"> fas fa-hdd</v-icon>
                <span style="text-align: center"> Almacenamiento </span>
                <span style="text-align: end">{{ getStorage }} GB</span>
              </div>
              <v-progress-linear
                :value="(device.storage_usage / device.storage_total) * 100"
                :color="
                  (device.storage_usage / device.storage_total) * 100 < 80
                    ? 'green'
                    : 'red'
                "
                style="border-radius: 20px; max-width: 95%"
                class="mt-5"
                height="15"
              >
              </v-progress-linear>
            </v-col>
          </v-row>

          <v-row class="map">
            <!-- <v-col v-if="loading" cols="12" sm="8" md="8">
              <v-skeleton-loader type="image"></v-skeleton-loader>
            </v-col> -->
            <!-- <v-col v-else cols="12" sm="8" md="8">
              <l-map
                v-if="!loading"
                :zoom="zoom"
                :center="center"
                :options="mapOptions"
                style="height: 340px"
              >
                <l-tile-layer :url="url" :attribution="attribution" />
                <l-marker :lat-lng="center" :icon="getImage">
                  <l-tooltip
                    :options="{ permanent: true, interactive: true }"
                    >{{ device.location }}</l-tooltip
                  >
                </l-marker>
              </l-map>
            </v-col> -->
            <v-col cols="12" sm="4" md="4">
              <v-btn
                :loading="loading"
                class="flex-grow-1 flex-shrink-0 white--text"
                large
                :disabled="!device.is_online"
                rounded
                @click="
                  ask({
                    name: `reiniciar el dispositivo ${device.device_name}`,
                    description:
                      'El dispositivo de reiniciará después de unos segundos',
                    action: 'restart',
                  })
                "
                :elevation="0"
                :minHeight="48"
                block
                color="warning darken-1"
              >
                Reiniciar dispositivo
              </v-btn>
              <span class="ml-5"
                >El dispositivo de reiniciará después de unos segundos</span
              >
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-btn
                :loading="loading"
                class="flex-grow-1 flex-shrink-0 white--text"
                large:disabled="!device.is_online"
                :disabled="!device.is_online"
                rounded
                :elevation="0"
                :minHeight="48"
                block
                color="red darken-4"
                @click="
                  ask({
                    name: `apagar el dispositivo ${device.device_name}`,
                    description:
                      'El dispositivo se apagará después de unos segundos, para encenderlo nuevamente debe hacerlo de forma manual.',
                    action: 'shutdown',
                  })
                "
              >
                Apagar dispositivo
              </v-btn>
              <span class="pl-5"
                >El dispositivo se apagará después de unos segundos, para
                encenderlo nuevamente debe hacerlo de forma manual.</span
              >
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-btn
                :loading="loading"
                class="flex-grow-1 flex-shrink-0 white--text"
                large
                :disabled="!device.is_online"
                rounded
                :elevation="0"
                :minHeight="48"
                block
                @click="
                  ask({
                    name: `eliminar los datos almacenados en ${device.device_name}`,
                    description:
                      'La información multimedia almacenada en el dispositivo se eliminará, esta acción no se puede revertir.',
                    action: 'purge',
                  })
                "
                color="red darken-4"
              >
                Eliminar datos almacenados
              </v-btn>
              <span class="pl-5"
                >La información multimedia almacenada en el dispositivo se
                eliminará, una vez completa no existe forma de
                recuperarla.</span
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-dialog max-width="600px" v-if="confirmDialog" v-model="confirmDialog">
      <confirm
        ref="confirmComponent"
        @success="actionConfirmed()"
        :message="action.description"
        :name="action.name"
        @cancel="confirmDialog = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import { db, fb } from "@/firebase";
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");
import confirm from "@/components/confirm";

import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LTooltip, LIcon } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";

export default {
  name: "device-status",
  props: ["screen"],
  components: {
    LMap,
    LTileLayer,
    LIcon,
    LMarker,
    LTooltip,
    confirm,
  },
  data() {
    return {
      snackbarText: "",
      snackbar: false,
      loading: true,
      device: {},
      confirmDialog: false,
      action: {},
      zoom: 30,
      center: latLng(47.41322, -1.219482),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
      },
    };
  },
  computed: {
    getStorage() {
      return `${(this.device.storage_usage / 1024).toFixed(2)}/${(
        this.device.storage_total / 1024
      ).toFixed(2)}`;
    },
    getMemory() {
      return `${(this.device.memory_usage / 1024).toFixed(2)}/${(
        this.device.memory_total / 1024
      ).toFixed(2)}`;
    },
    getDate() {
      return moment(this.device.last_connectivity_event).format("llll");
    },
    getImage() {
      return L.icon({
        iconUrl: require("@/assets/map-marker.png"),
        iconSize: [50, 50],
        iconAnchor: [0, 20],
        shadowAnchor: [4, 62],
        popupAnchor: [-3, -76],
      });
    },
  },
  methods: {
    getDeviceStatus() {
      this.loading = true;
      var deviceStatus = fb.functions().httpsCallable("httpDeviceStatus");
      deviceStatus({ screenId: this.screen[".key"] })
        .then((result) => {
          this.device = result.data.data;
          this.center = latLng(this.device.latitude, this.device.longitude);
          this.loading = false;
        })
        .catch((err) => {
          this.snackbarText =
            "Ocurrió un error inesperado, inténtelo nuevamente.";
          this.snackbar = true;
          this.loading = false;
          this.$emit("cancel");
        });
    },
    ask(item) {
      this.action = item;
      this.confirmDialog = true;
    },
    actionConfirmed() {
      var devicesActions = fb.functions().httpsCallable("httpDevicesActions");
      devicesActions({
        screenId: this.screen[".key"],
        action: this.action.action,
      })
        .then((result) => {
          this.$refs.confirmComponent.loading = false;
          this.snackbarText = `El dispositivo se ${
            this.action.action == "shutdown" ? "apagará" : "reiniciará"
          } en unos segundos`;
          this.snackbar = true;
          this.confirmDialog = false;
        })
        .catch((err) => {
          console.log(err);
          this.$refs.confirmComponent.loading = false;
          this.snackbarText =
            "Ocurrió un error inesperado, inténtelo nuevamente.";
          this.snackbar = true;
          this.loading = false;
        });
    },
  },

  mounted() {
    this.getDeviceStatus();
  },
};
</script>

<style scoped>
i {
  margin-right: 10px;
}

.item {
  display: grid;
  grid-template-columns: 20% 40% 40%;
  font-size: 15px;
  font-weight: bold;
  justify-content: center;
  align-items: center;
}

.online {
  color: green;
  font-size: 18px;
  font-weight: bold;
}

.offline {
  color: rgb(116, 0, 0);
  font-size: 18px;
  font-weight: bold;
}

.backColor {
  background-color: #eaeaea;
  border-radius: 10px;
  margin-right: 10px;
}

.general {
  display: grid;
  grid-template-columns: 50% 45% 5%;
}

.general i {
  text-align: end;
  font-size: 20px;
  cursor: pointer;
}

.map {
  width: 100%;
  /* background-color:red;  */
  /* min-height: 300px; */
  margin-top: 30px;
  padding: 20px;
}
</style>